import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';

import Expand from '../../components/icons/expand';

import './index.scss';

class DropdownList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      active: false,
      selected: props.byoQuantity,
    };
  }

  /**
   * Method to handle document click which hides items when click outside current dropdownlist.
   * @param e [object] The Synthetic React event object
   */
  handleDocumentClick = (e) => {
    const {active} = this.state;
    if (active && this.rootNode && !this.rootNode.contains(e.target)) {
      this.setState({active: false});
    }
  };

  /**
   * Method to handle the selection of an item option.
   * @param item [Integer] The Item object Instance.
   *
   */
  onSelect = (item) => {
    const {selected} = this.state;
    const prevSelectedNum = selected ? selected : null;
    const selectedNum = item || null;
    const {onSelection} = this.props;
    if (prevSelectedNum !== selectedNum) {
      // Invoke callback if value is different than previous.
      onSelection(item);
    }
    this.setState({active: true, selected: item});
  };

  /**
   * Method to handle the Dropdown Expand Action to contents of the dropdown.
   *
   */
  expand = () => {
    this.setState({active: true});
  };

  /**
   * Method to handle the Dropdown Close Action and reset the state of the dropdown.
   *
   */
  close = () => {
    this.setState({active: false});
  };

  /**
   * Method to handle the Dropdown Expand and Close Action as a toggle state
   *
   */
  toggleMenu = (e) => {
    const {active} = this.state;
    if (active) {
      this.close(e);
    } else {
      this.expand(e);
    }
  };

  /**
   * React Component Lifecycle Methods.
   *
   */
  componentDidMount() {
    document.addEventListener('click', this.handleDocumentClick);
  }

  componentDidUpdate(prevProps) {
    const {byoQuantity} = this.props;
    if (prevProps.byoQuantity !== byoQuantity) {
      this.onSelect(byoQuantity);
    }
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleDocumentClick);
  }

  addTicketStr(quantity) {
    const ticketStr = (
      <span>
        <FormattedMessage
          id="event-royal.react-build-your-order.ticketqty"
          values={{quantity}}
          defaultMessage="{quantity} {quantity, plural, one {ticket} other {tickets}}"
        />
      </span>
    );

    return ticketStr;
  }

  renderTicketList() {
    const {splitVector} = this.props;

    const {active, selected} = this.state;
    if (active) {
      const ticketListItems = splitVector.map((qty) => {
        let bold = '';
        if (selected && qty === selected) {
          bold = 'DropdownList__item--bold';
        }
        const itemStr = this.addTicketStr(qty);

        return (
          <li
            key={`BYO Dropdown Item ${qty}`}
            className={`DropdownList__item ${bold}`}
            data-value={`${qty}`}
            onClick={() => this.onSelect(qty)}
          >
            {itemStr}
          </li>
        );
      });

      return <ul className="DropdownList__items">{ticketListItems}</ul>;
    }

    return null;
  }

  render() {
    const {disabled} = this.props;
    const {active, selected} = this.state;

    const darkBorder = active ? 'DropdownList__btn--darkBorder' : '';
    const disabledClass = disabled ? 'DropdownList__btn--disabled' : '';
    const selectedTicketQty = this.addTicketStr(selected);

    const dropdownButtonContents = (
      <div className="DropdownList__display">
        <div>
          <div className="DropdownList__display__header">
            <FormattedMessage id="event-royal.react-dropdown.header" defaultMessage="Quantity" />
          </div>
          <div className="DropdownList__display__text">{selectedTicketQty}</div>
        </div>
        <Expand color="#2F343B" width="12px" />
      </div>
    );

    return (
      <div
        className={`DropdownList__btn ${darkBorder} ${disabledClass}`}
        disabled={disabled}
        ref={(node) => {
          this.rootNode = node;
        }}
        onClick={!disabled ? this.toggleMenu : null}
      >
        {dropdownButtonContents}
        {this.renderTicketList()}
      </div>
    );
  }
}

DropdownList.propTypes = {
  onSelection: PropTypes.func.isRequired,
  splitVector: PropTypes.arrayOf(Number).isRequired,

  /** Is dropdown list disabled? */
  disabled: PropTypes.bool,
  byoQuantity: PropTypes.number,
};

DropdownList.defaultProps = {
  disabled: false,
};

export default DropdownList;
